<template>
    <div class="container container--sav-list">

        <Loader v-if="!isReady"></Loader>

        <List v-else
            :filtering="this"
            :itemNameSingular="'résultat'"
            :itemNamePlural="'résultats'" >
            
            <template v-slot:filters>

                <ClientFilter v-model="filters.client_id"
                    :clients="clients"/>

                <SiteFilter v-model="filters.site_id"
                    :clientAddresses="clientAddresses"/>                    

            </template>

            <template v-if="hasContent">

                <Message type="info">
                    Pour consulter les interventions techniques, nous vous invitons à cliquer sur l'adresse souhaitée ci-dessous.
                </Message>
                
                <Block>
                    <Box v-for="item in items" :key="item.id">
                        <collapse :hidden="!item.address" :selected="true">
                            <template slot="collapse-header">                                       
                                <div  class="sav-client">
                                    <a @click.stop v-if="item.savURL"
                                        class="sav-client__title"
                                        target="_blank"
                                        :href="item.savURL">
                                        <i class="fa fa-wrench"></i>
                                        <span>{{item.name}}</span>
                                    </a>
                                    <span v-if="!item.savURL" class="sav-client__title">{{item.name}}</span>
                                </div>
                            </template>
                            <template slot="collapse-body">
                                <div class="sav-address" 
                                    v-for="address in item.address"
                                    :key="address.id">
                                    <a class="sav-address__title"
                                        target="_blank"
                                        :href="address.savURL">
                                        <i class="fa fa-wrench"></i>
                                        <span>{{address.addressCode}} - {{address.label}}</span>
                                    </a>            
                                </div>
                            </template>
                        </collapse>    
                    </Box>                
                </Block>

            </template>
            
            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun résultat</h1>
            </div>

        </List>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Block from '@/components/block/Block.vue'
import Box from '@/components/box/Box.vue'
import ClientFilter from '@/components/list/filters/ClientFilter.vue'
import Collapse from '@/components/collapse/Collapse.vue'
import List from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import Message from '@/components/message/Message.vue'
import SiteFilter from '@/components/list/filters/SiteFilter.vue'

import api from '@/api/proxyWeb/sav'

import filtering from "@/containers/filtering"

import  { useClientAddresses } from '@/helpers/clientAddress'

export default {

    name: 'sav',

    data: function() {
        return {
            filters: {
                client_id: null,
                site_id: null
            }
        }
    },

    computed: {

        ...mapState({

            clients: state => state.clients.all,

            clientAddresses: function(state) {
                return useClientAddresses(state.clients.all, this.filters.client_id)
            }            
        })
    },

    created () {
        this.useFilter(api)
    },

    components: {
        Block,
        Box,
        ClientFilter,
        Collapse,
        List,
        Loader,
        Message,
        SiteFilter
    },

    mixins: [ filtering ]
}
</script>

<style>

.sav-address {
    margin-top: 1rem;
    margin-left: 2rem;
}

.sav-client
{
    font-size: 1.1rem;
    font-weight: bold;
}

.sav-address .sav-address__title,
.sav-client .sav-client__title {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    text-decoration: none;
}

.sav-address .sav-address__title > span,
.sav-client .sav-client__title > span {
    text-decoration: underline;
}

</style>